import { useQuery } from 'react-query';

import { toOptionsCurry } from 'utils/toOptions';

import { getAdministrationEmployees } from 'RestAPIs/admin';

export const useGetLinkedEmployeeOptions = (noAccount = true) => {
  return useQuery({
    queryFn: () => getAdministrationEmployees(noAccount),
    queryKey: ['LinkedEmployeeOptions'],
    select: toOptionsCurry('empId', 'nameCompound')
  });
};
